import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=4b38d579&scoped=true&external"
import script from "./SearchOrders.vue?vue&type=script&lang=js"
export * from "./SearchOrders.vue?vue&type=script&lang=js"
import style0 from "./SearchOrders.vue?vue&type=style&index=0&id=4b38d579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38d579",
  null
  
)

export default component.exports